import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/media-schema'
const { infoScreenPosterSchema: schema } = schemaSettings
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const service = apiClient.service('media')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'medias', storePrefix: name }),
    design: { generating: false, errorMessage: '' },
    filter: {
      displayLocation: 'signage',
      devices: [],
      timeRange: 'now',
      scheduleAt: null,
      scheduleEndAt: null,
      excludeParentMedia: false,
    },
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
